import { __ } from '@wordpress/i18n'

export default {
  kontakt: __('Kontakt', 'dhsv_theme'),
}
